import { Component, ChangeDetectionStrategy, OnInit, ChangeDetectorRef, HostBinding } from '@angular/core';
import { Router, Event as RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

@Component({
	selector: 'router-loader',
	template: `
		<go-suite-loader *ngIf="loading"></go-suite-loader>
		<div class="window-background"></div>
	`,
	styleUrls: ['./router-loader.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouterLoaderComponent implements OnInit {
	public loading: boolean = false;

	@HostBinding('class.hidden') get hidden(): boolean {
		return !this.loading;
	}

	constructor(
		private _router: Router,
		private _changeDetectorRef: ChangeDetectorRef
	) {}

	public ngOnInit(): void {
		this._router.events.subscribe((event: RouterEvent) => this.navigationInterceptor(event));
	}

	protected navigationInterceptor(event: RouterEvent): void {
		switch (true) {
			case event instanceof NavigationStart:
				this.loading = true;
				break;
			case event instanceof NavigationEnd:
				this.loading = false;
				break;
			case event instanceof NavigationCancel:
				this.loading = false;
				break;
			case event instanceof NavigationError:
				this.loading = false;
				break;
		}

		this._changeDetectorRef.markForCheck();
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/router-loader/router-loader.component.ts